/**
 * SubmenuDivHandler
 */
export abstract class SubmenuDivHandler {
    static TypeName = 'SubmenuDivHandler';

    constructor () {

    }

    abstract updateConditionals(): void;

    abstract displayMenuContent(containerDiv : HTMLDivElement): void;

    abstract hideContent(): void;
}
